import Cookies from 'js-cookie'

import { authenticationLogout } from './authentication'

export const ActionTypes = {
  APP_INITIALIZING: 'APP_INITIALIZING',
  APP_INITIALIZED: 'APP_INITIALIZED',
}

export const getPlusCookie = config => {
  let plusCookie = Cookies.get(config.CookiesName)
  if (!plusCookie) plusCookie = Cookies.get(config.bibme.cookieName)
  return plusCookie
}

export const getAccessTokenCookie = config => {
  const accessToken = Cookies.get(config.accessTokenCookie)
  return accessToken || ''
}

export const cookieAuthSync = (ignore, api, config) => {
  if (ignore) {
    return Promise.resolve()
  }

  const plusCookie = Cookies.get(config.cookieName)

  if (plusCookie) {
    const accessToken = getAccessTokenCookie(config)
    const tokens = { id_token: plusCookie, access_token: accessToken }
    return api.loginPlusUser(tokens).then(loginData => {
      config.setToken(loginData.access_token)
    }, () => false) // eventually, the JWT from the cookie will expire - not a real error, ignoring
  }
  return Promise.resolve()
}

export const initializeConfiguration = withoutCookieSync => (dispatch, getState, { api, config, gapi }) => {
  dispatch({ type: ActionTypes.APP_INITIALIZING })
  return cookieAuthSync(withoutCookieSync, api, config)
    .then(() => api.loadConfig())
    .then(data => {
      config.init(data.config)
      api.init(data._links) // eslint-disable-line no-underscore-dangle

      gapi.init().then(gapi.onApiLoad)

      dispatch({
        type: ActionTypes.APP_INITIALIZED,
        config: {
          debug: config.debug,
          environment: config.environment,
          upload: config.upload,
          site: data.config.site,
        },
      })
    })
    .catch(error => {
      if (error.status === 403) {
        dispatch(authenticationLogout())
        dispatch(initializeConfiguration(withoutCookieSync))
      }
    })
}
